export default __webpack_public_path__ + "static/media/git.5eab40a0.png";